import {
    LiveboardEmbed,
    AuthType,
    init,
    logout,
    AuthStatus,
    Action,
} from "@thoughtspot/visual-embed-sdk";

import {
    ThoughtSpotRestApi,
    createBearerAuthenticationConfig,
} from "@thoughtspot/rest-api-sdk";

import { THOUGHTSPOT_CONFIG } from "../_redux/_constants/insights.constant";

let authInitialized = false;

export function initThoughtSpot() {
    if (authInitialized) return;
    authInitialized = true;

    const host = THOUGHTSPOT_CONFIG.THOUGHTSPOT_HOST_URL;
    if (!host) {
        console.error("ThoughtSpot host not configured");
        return;
    }
    try {
        const authStatus = init({
            thoughtSpotHost: host,
            authType: AuthType.Basic,
            username: THOUGHTSPOT_CONFIG.THOUGHTSPOTTER_USERNAME,
            password: THOUGHTSPOT_CONFIG.THOUGHTSPOTTER_PASSWORD,
            autoLogin: true, // relogin automatically when user session expired
        });

        // authStatus.on(AuthStatus.FAILURE, (reason) => {
        //     logout();
        // });
    } catch (e) {
        authInitialized = false;
        console.error("ThoughtSpot init failed", e);
    }
}

/**
 * This will create a bearer authenticated client to connect to thoughtspot server
 * 
 * @returns ThoughtSpotRestApi
 *  thoughtSpotHost: process.env.THOUGHTSPOTTER_HOST_URL,
     authType: AuthType.Basic,
     username: process.env.THOUGHTSPOTTER_USERNAME,
     password: process.env.THOUGHTSPOTTER_PASSWORD,
 *
 * */
let thoughtSpotClient = null;
export const initThoughtspotRestAPI = () => {
    if (!thoughtSpotClient) {
        const config = createBearerAuthenticationConfig(
            process.env.THOUGHTSPOTTER_HOST_URL,
            {
                username: process.env.THOUGHTSPOTTER_USERNAME,
                password: process.env.THOUGHTSPOTTER_PASSWORD,
            },
        );

        // create a thoughtspot client
        thoughtSpotClient = new ThoughtSpotRestApi(config);
    }
    return thoughtSpotClient;
};

// return the thougtspot REST API instance
export const getThoughtSpotClient = () => {
    if (thoughtSpotClient) {
        return thoughtSpotClient;
    }

    return initThoughtspotRestAPI();
};

// TODO: For Develop Server token username based authentication
// fetch auth token from token server
// let cachedTokenResponse = null;

// export const getCachedAuthToken = async () => {
//     // if token has 30s remaining, return cached token
//     if (
//         cachedTokenResponse &&
//         cachedTokenResponse.expiration_time_in_millis - Date.now() > 30 * 1000
//     ) {
//         return cachedTokenResponse.token;
//     }
//     // fetch new token

//     const username = process.env.THOUGHTSPOTTER_USERNAME;

//     const response = await fetch(`/api/rest/2.0/auth/token/full`, {
//         headers: {
//             "x-my-username": username,
//         },
//     });
//     const data = await response.json();
//     cachedTokenResponse = data;
//     return data.token;
// };
